export default __webpack_public_path__ + "static/media/DAIF_Services_Screen2_in-end.19378cac.jpg";